import { ArrowBack } from '@mui/icons-material'
import { Box, Button, CircularProgress, Grid, Link, TextField } from '@mui/material'
import ImageBanner from 'components/image-banner'
import LogoTheme from 'components/logo-theme'
import MailBannerSVG from 'components/svg/mail-banner'
import WrapperPermission from 'components/wrapper-permission'
import { useStyles } from './styles'
import useComponent from './use-component'

const VerifyEmail = () => {
  const classes = useStyles()
  const { handleBack, handleChange, handleKeyDown, inputStates, isLoading, onSubmit, resendCode, theme, user } =
    useComponent()

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.connectBox}>
            <LogoTheme />

            <h1 className={classes.formTitle}>Verifique seu e-mail</h1>
            <span className={classes.formSubTitle}>
              Acabamos de enviar um código de confirmação de 6 dígitos para <b>{user && user.email}</b>. Por favor,
              insira o código na caixa abaixo.
            </span>

            <div
              style={{
                display: 'flex',
                gap: 12,
                justifyContent: 'center',
                marginTop: 12,
              }}
            >
              {inputStates.map((state, index) => {
                return (
                  <TextField
                    key={index}
                    type='number'
                    variant='outlined'
                    className={classes.numberField}
                    value={state.digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={handleKeyDown}
                    style={{ height: '56px', textAlign: 'center' }}
                    inputProps={{ maxLength: 1, className: 'numberField' }}
                  />
                )
              })}
            </div>

            <Box
              marginTop={3}
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              width='100%'
            >
              <Button
                fullWidth
                variant='contained'
                onClick={onSubmit}
                size='large'
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress
                    color='inherit'
                    size={26}
                  />
                ) : (
                  'VERIFICAR'
                )}
              </Button>
            </Box>

            <Grid
              item
              xs={12}
              className={classes.resendMail}
            >
              Não tem um código?&nbsp;
              {isLoading ? (
                <Link
                  variant='body1'
                  data-testid='signup-link'
                  underline='none'
                  sx={{
                    cursor: 'default',
                    color: 'gray',
                  }}
                >
                  Reenviar código
                </Link>
              ) : (
                <Link
                  onClick={resendCode}
                  variant='body1'
                  data-testid='signup-link'
                  underline='none'
                  sx={{
                    cursor: 'pointer',
                    color: 'blue',
                  }}
                >
                  Reenviar código
                </Link>
              )}
            </Grid>

            <Grid container>
              <Grid
                item
                xs={12}
              >
                <Box
                  onClick={handleBack}
                  data-testid='signup-link'
                  className={classes.signupLink}
                >
                  <ArrowBack
                    color='inherit'
                    sx={{ marginRight: '8px' }}
                  />
                  Voltar para a página de Login
                </Box>
              </Grid>
            </Grid>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='Falta pouco para você ter o Cofre Digital da Conducco.'
          banner={<MailBannerSVG />}
        />
      </Box>
    </Box>
  )
}

export default VerifyEmail
